module.exports = {
  schema: {
    name: '設計資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        unique: true,
        name: '設計代碼',
      },
      name: {
        type: 'String',
        name: '設計名稱',
      },
      type: {
        type: 'String',
        name: '設計類別',
        // options: ['單光', '雙光', '漸進遠中近', '漸進室內中距', '漸進近近', '玻璃遠中近', '兒控'],
      },
      method: {
        type: 'String',
        name: '設計方式',
        // options: ['外面漸進', '內面漸進', '雙面漸進', '減壓'],
      },
    },
  },
  index: {
    primary: {
      key: {
        name: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 90 },
        { key: 'name', width: 200 },
        { key: 'type', width: 150 },
        { key: 'method', width: 100 },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'type' }],
            [{ key: 'method' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/lensDesigns.js